import { render, staticRenderFns } from "./modalUpload.vue?vue&type=template&id=2b78dd9a&scoped=true"
import script from "./modalUpload.vue?vue&type=script&lang=js"
export * from "./modalUpload.vue?vue&type=script&lang=js"
import style0 from "./modalUpload.vue?vue&type=style&index=0&id=2b78dd9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b78dd9a",
  null
  
)

export default component.exports